<template>
  <div class="content">
    <div class="contentPrincipal">
      <div class="myContent">
      <div class="tabContent">
        <div class="tabElement contrat active" @click="changeTab('contrat')">
          <span class="material-icons-sharp"> shopping_cart </span>Bon de
          commande en attente de paiement
        </div>
        <div class="tabElement allBon" @click="changeTab('allBon')">
          <span class="material-icons-sharp"> app_registration </span>Tous les
          bons de commande
        </div>
        <div
          class="tabElement customerWallet"
          @click="changeTab('customerWallet')"
        >
          <span class="material-icons-sharp"> account_balance_wallet </span
          >Gestion des comptes clients
        </div>
      </div>
      </div>
      <div id="contratTab" class="tabElementContent active">
        <!-- <div @click="addNewCustomerCommande" class="buttonAdd">
          <span> Ajouter un bon de commande</span>
        </div> -->
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeader" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <img v-if="card.length == 0" src="../assets/empty2.png" alt="" />
            <tbody v-else>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in card"
                :key="item._id"
              >
                <!-- <td>
                  <div class="nameContentButton">
                    <div
                      @click="addNewContratDetails(item)"
                      class="buttonAddSecond"
                    >
                      <span> Voir article</span>
                    </div>
                  </div>
                </td> -->
                <td @click="editeContratRow(item)">{{ item.number }}</td>
                <td @click="editeContratRow(item)">
                  {{ item.status }}
                </td>
                <td @click="editeContratRow(item)">
                  {{ item.customer ? item.customer.name : "" }}
                </td>
                <td @click="editeContratRow(item)">
                  {{ item.amount }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="allBonTab" class="tabElementContent">
        <!-- <div @click="addNewCustomerCommande" class="buttonAdd">
          <span> Ajouter un bon de commande</span>
        </div> -->
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeaderAll" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <img v-if="card.length == 0" src="../assets/empty2.png" alt="" />
            <tbody v-else>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in card"
                :key="item._id"
              >
                <td>
                  <div class="nameContentButton">
                    <div v-if="item.status !='Attente'" @click="printAllBon(item)" class="buttonAddSecond">
                      <span> Imprimer les bons</span>
                    </div>
                  </div>
                </td>
                <td>{{ item.number }}</td>
                <td>
                  {{ item.status }}
                </td>
                <td>
                  {{ item.customer ? item.customer.name : "" }}
                </td>
                <td>
                  {{ item.amount }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="customerWalletTab" class="tabElementContent">
        <!-- <div @click="addNewCustomerCommande" class="buttonAdd">
          <span> Ajouter un bon de commande</span>
        </div> -->
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeaderCustomerWallet" :key="item">
                  {{ item }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in customerListData"
                :key="item._id"
              >
                <td>
                  <div class="nameContentButton">
                    <div
                      @click="crediteCustomerBalance(item)"
                      class="buttonAddSecond"
                    >
                      <span> Créditer le compte</span>
                    </div>
                  </div>
                </td>
                <td>
                  {{ item.name }}
                </td>
                <td>
                  {{ item.phones.join("/") }}
                </td>
                <td>
                  {{ item.email }}
                </td>
                <td>
                  {{ item.address }}
                </td>
                <td>
                  {{ item.role }}
                </td>
                <td>
                  {{ item.wallet.balance }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "caisseView",
  components: {},
  data: () => ({
    tableHeader: ["Numéro de Commande", "Statut", "Client", "Montant Total"],
    tableHeaderAll: ["","Numéro de Commande", "Statut", "Client", "Montant Total"],
    isSelecteds: [],
    isSelectedAll: false,
    loading: true,
    tableHeaderCustomerWallet: [
      "",
      "Nom /  Raison sociale",
      "Contact",
      "Email",
      "Adresse",
      "Type de client",
      "Solde portefeuille",
    ],
    tableHeaderBl: [
      "Contrat",
      "Numéro BL",
      "Nbr de conteneur",
      "Port de chargement",
      "Navire",
      "Ligne",
      "Destination",
      "Etdpol",
      "Eta",
      "Observation",
    ],
    tableHeaderConteneur: [
      "Commande",
      "Désignation",
      "Type de conteneur",
      "Numéro BL",
      "Produit",
      "Magasin",
      "Date de sourti",
      "Transitaire",
      "Montant Transitaire",
      "Montant total",
      "Observation",
    ],
    tableHeaderConteneurNone: [
      "",
      "Commande",
      "Désignation",
      "Type de conteneur",
      "Numéro BL",
      "Produit",
      "Transitaire",
      "Montant Transitaire",
      "Montant total",
      "Observation",
    ],
  }),
  watch: {
    contenuerAllData() {
      this.isSelecteds = [];
    },
  },
  computed: {
    ...mapGetters([
      "contratData",
      "blData",
      "conteneurData",
      "contenuerAllData",
      "storeData",
      "card",
      "customerListData",
    ]),
  },
  async mounted() {
    await this.getCard({ status: "Envoyé à la caisse" });
  },
  methods: {
    ...mapActions([
      "getCustomerList",
      "getProduct",
      "getContrat",
      "getStore",
      "getCard",
      "getCustomerWallet",
      "printBon",
      "printBonMagasin",
      "printBonFacture",
    ]),
    raccourcirTexte(texte) {
      return texte;
    },
    async printAllBon(item) {
      try {
        this.$emit("show", true);
        // await this.printBon({ id: item._id });
        await this.printBonMagasin({ id: item._id });
        await this.printBonFacture({ id: item._id });
      } catch (error) {
        // Gérer l'erreur ici, par exemple, en affichant un message à l'utilisateur ou en journalisant l'erreur.
        console.error(
          "Une erreur est survenue lors de l'impression des bons :",
          error
        );
      } finally {
        // Cela sera exécuté quel que soit le résultat des tentatives précédentes.
        this.$emit("show", false);
      }
    },
    async addNewCustomerCommande() {
      this.$emit("show", true);
      await this.getCustomerList({});
      await this.getProduct({});
      await this.getStore({});
      const value = {
        modalType: "customerCommande",
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "customerCommande",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    async crediteCustomerBalance(item) {
      this.$emit("show", true);
    
      if (!item.isSelected) {
        for (let i = 0; i < this.customerListData.length; i++) {
          this.customerListData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.customerListData);
        const value = {
          _id: item._id,
          modalType: "caisseCrediteCustomerBalance",
          customerName: item.name,
          customer: item._id,
          balance: item.wallet.balance,
          name: "Envoi d'argent sur compte",
          // amount: item.amount,
        };
        this.$emit("editeRowForDash", {
          name: "caisseCrediteCustomerBalance",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },

    async editeContratRow(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.card.length; i++) {
          this.card[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.card);
        const value = {
          _id: item._id,
          modalType: "customerPayeToCaisse",
          number: item.number,
          name: item.customer.name,
          balance: 0,
          amount: item.amount,
        };
        await this.getCustomerWallet({
          customer: item.customer._id,
        })
          .then((res) => {
            console.log("custometWallet", res);
            value.balance = res[0].balance;
          })
          .catch((error) => {
            console.error(error);
          });
        this.$emit("editeRowForDash", {
          name: "customerPayeToCaisse",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async editeBlRow(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.blData.length; i++) {
          this.blData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.blData);
        await this.getContrat({});
        const value = {
          _id: item._id,
          modalType: "bl",
          observation: item.observation,
          number: item.number,
          shipName: item.shipName,
          lineName: item.lineName,
          loadingPort: item.loadingPort,
          etdPol: item.etdPol,
          destination: item.destination,
          eta: item.eta,
          contract: item.contract ? item.contract.number : "",
        };
        this.$emit("editeRowForDash", {
          name: "bl",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async editeConteneurRow(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.contenuerAllData.length; i++) {
          this.contenuerAllData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log("OK", item);
        await this.getConteneur();
        await this.getContratDetails({});
        await this.getBl({});
        await this.getTransitaire();

        const value = {
          _id: item._id,
          modalType: "conteneurPrincipaleAll",
          observation: item.observation,
          containType: item.containType ? item.containType.name : "",
          store: item.store ? item.store.name : "",
          contractDetail: item.contractDetail ? item.contractDetail.number : "",
          name: item.name,
          bl: item.bl ? item.bl.number : "",
          product: item.product ? item.product.name : "",
          outDate: item.outDate,
          transitaire: item.transitaire ? item.transitaire.fullName : "",
          transitaireAmount: item.transitaireAmount,
          amount: item.amount,
        };
        this.$emit("editeRowForDash", {
          name: "conteneurPrincipaleAll",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async addNewContratDetails(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.contratData.length; i++) {
          this.contratData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.contratData);
        const value = {
          _id: item._id,
          modalType: "commande",
          number: item.number,
          supplier: item.supplier.fullName,
          observation: item.observation,
        };
        await this.getContratDetails({ contract: item._id });
        this.$emit("editeRowForDash", {
          name: "commande",
          size: 1000,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    //     makeSelectAll() {

    //   if (!this.isSelectedAll) {
    //     this.isSelectedAll = true;

    //     this.contenuerAllData.forEach((resourceItem) => {
    //       resourceItem.isSelected = true;
    //       this.isSelected.push(resourceItem._id);
    //     });

    //   } else {
    //     this.isSelectedAll = false;

    //     this.contenuerAllData.forEach((resourceItem) => {

    //       const index = this.isSelected.indexOf(resourceItem._id);
    //       resourceItem.isSelected = false;
    //       if (index !== -1) {
    //         this.isSelected.splice(index, 1);
    //       }
    //     });
    //   }
    // },
    makeSelect(item) {
      if (!item.isSelected) {
        item.isSelected = true; // Met item.isSelected à true

        this.isSelecteds.push(item._id);
      } else {
        item.isSelected = false;

        const index = this.isSelecteds.indexOf(item._id);
        if (index !== -1) {
          this.isSelecteds.splice(index, 1);
        }
      }
      // alert(JSON.stringify(this.selectedItemsIds));
    },
    async changeTab(tabName) {
      this.$emit("closeAllModal");
      if (tabName === "contrat") {
        await this.getCard({ status: "Envoyé à la caisse" });
      } else if (tabName === "customerWallet") {
        await this.getCustomerList({});
      } else if (tabName === "allBon") {
        await this.getCard({ status: "" });
      }
      // Masquer tous les onglets
      var tabContents = document.querySelectorAll(".tabElementContent");
      tabContents.forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

      // Afficher l'onglet sélectionné
      var selectedTab = document.getElementById(tabName + "Tab");
      selectedTab.classList.add("active");

      // Mettre à jour l'état actif des onglets de la barre de navigation
      var tabElements = document.querySelectorAll(".tabElement");
      tabElements.forEach(function (tabElement) {
        tabElement.classList.remove("active");
      });

      var selectedTabElement = document.querySelector(".tabElement." + tabName);
      selectedTabElement.classList.add("active");
    },
  },
};
</script>
    